<script setup lang="ts">
import { ref } from 'vue'
import MessageInboxItem from '../components/MessageInboxItem.vue'
import BannerOffline from '../components/BannerOffline.vue'
import FormMessage from '../components/FormMessage.vue'
import { storeToRefs } from 'pinia'
import { useMessages } from '../store/useMessages'
import { useQuasar } from 'quasar'
import { useI18n } from 'vue-i18n'
import { useNetwork } from '../composables/useNetwork'

const { getStatus } = useNetwork()
const { t } = useI18n({ useScope: 'global' })
const messageLabel = (label: string) => t(`messaging.${label}`)
const formLabel = (label: string) => t(`form.${label}`)

const modalNewMessage = ref(false)
const tab = ref('inbox')

const {
  getMessagesInbox: inboxMessages,
  getMessagesOutbox: outboxMessages,
  unread,
} = storeToRefs(useMessages())
const { markRead, send } = useMessages()

//for ripple
const $q = useQuasar()
defineExpose({ $q })
</script>
<template>
  <BannerOffline data-test="pageInventory">
    {{ messageLabel('offline') }}
  </BannerOffline>
  <q-page>
    <div class="q-pa-md">
      <h1 class="text-h4 text-weight-medium">Messages</h1>
      <div class="q-mt-sm">
        <q-btn
          color="primary"
          rounded
          no-caps
          :label="formLabel('newMessage')"
          @click="getStatus ? (modalNewMessage = true) : undefined"
        />
      </div>
    </div>

    <q-tabs
      v-model="tab"
      class="text-grey"
      active-color="secondary"
      indicator-color="secondary"
      align="left"
      inline-label
      narrow-indicator
    >
      <q-tab name="inbox" :label="messageLabel('inbox')">
        <q-badge v-if="unread" color="secondary" floating>{{ unread }}</q-badge>
      </q-tab>
      <q-tab name="sent" :label="messageLabel('sent')" />
    </q-tabs>
    <q-separator />
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="inbox" class="no-padding">
        <q-list separator>
          <template v-for="message in inboxMessages" :key="message.id">
            <MessageInboxItem
              :sent="false"
              @click="
                markRead(message.id), $router.push({ name: 'message', params: { id: message.id } })
              "
              v-bind="message"
            />
          </template>
          <p class="q-my-sm text-caption text-grey-7 text-center" v-if="1 > inboxMessages.length">
            {{ messageLabel('noMessagesInbox') }}
          </p>
        </q-list>
        <q-separator />
      </q-tab-panel>
      <!-- Sent -->
      <q-tab-panel name="sent" class="no-padding">
        <q-list separator>
          <template v-for="message in outboxMessages" :key="message.id">
            <MessageInboxItem
              sent
              @click="$router.push({ name: 'message', params: { id: message.id } })"
              v-bind="message"
            />
          </template>
          <p class="q-my-sm text-caption text-grey-7 text-center" v-if="1 > outboxMessages.length">
            {{ messageLabel('noMessagesOutbox') }}
          </p>
        </q-list>
        <q-separator />
        <p class="q-my-sm text-caption text-grey-7 text-center">
          {{ messageLabel('sentMessagesRemoved') }}
        </p>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>

  <q-dialog v-model="modalNewMessage">
    <q-card style="width: 480px; max-width: 80vw" class="q-pa-md">
      <FormMessage @send="send" />
    </q-card>
  </q-dialog>
</template>
